module.exports = __webpack_public_path__ + "img/1.01298b70.png";